import { UserContext } from '@/contexts/UserContextProvider';
import { setInterceptor } from '@/repositories/apiClient';
import axios from 'axios';
import React, { useContext, useEffect } from 'react';


const ApiInterceptor = ({children}) => {

  const {setToken} = useContext(UserContext);

  useEffect(() => {
    const responseInterfceptor = setInterceptor((token) => { setToken(token) });

    return () => {
      axios.interceptors.response.eject(responseInterfceptor);
    }
  }, [setToken]);
  return children
};


export default ApiInterceptor;
